import React, { Component } from "react";
import PropTypes from "prop-types";

import { Row, Col } from "react-bootstrap";
import Formsy from "formsy-react";
import { Input } from "formsy-react-components";

class RoleForm extends Component {
  constructor(props) {
    super(props);
    this.state = { canSubmit: false };
  }

  enableButton = () => {
    this.setState({ canSubmit: true });
  };

  disableButton = () => {
    this.setState({ canSubmit: false });
  };

  add = (model) => {
    this.props.onAdd(model);
    this.form.reset();
  };

  submit = (model) => {
    this.props.onSave(model);
    this.form.reset();
  };

  cancel = () => {
    this.props.onCancel();
  };

  render() {
    const { role, adding } = this.props;

    return (
      <Formsy
        ref={(ref) => (this.form = ref)}
        className="vertical form"
        onValidSubmit={adding ? this.add : this.submit}
        onValid={this.enableButton}
        onInvalid={this.disableButton}
      >
        <Row>
          <Col md={6}>
            <Input
              name="name"
              label="Name"
              placeholder="Name"
              value={role.name}
              validations={{ maxLength: 50 }}
              validationErrors={{
                maxLength: "You can not type in more than 50 characters"
              }}
            />
          </Col>
          <Col md={6}>
            <Input
              name="number"
              label="Number"
              placeholder="Number"
              value={role.number?.toString()}
            />
          </Col>
          <Col md={12} className="footer">
            <button
              type="button"
              style={!adding ? { display: "inline" } : { display: "none" }}
              className="btn  btn-cancel"
              onClick={this.cancel}
            >
              Cancel
            </button>
            <input
              className="btn  btn-success"
              type="submit"
              disabled={!this.state.canSubmit || this.props.saving}
              value={this.props.saving ? "Saving... " : "Save"}
            />
          </Col>
        </Row>
      </Formsy>
    );
  }
}

RoleForm.propTypes = {
  onSave: PropTypes.func.isRequired,
  saving: PropTypes.bool.isRequired,
  role: PropTypes.object.isRequired,
  adding: PropTypes.bool,
  onAdd: PropTypes.func,
  onCancel: PropTypes.func
};

export default RoleForm;
